var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emb",staticStyle:{"align-content":"center:align_items:center"}},[(_vm.label)?_c('div',{staticClass:"lb",style:(_vm.stilol)},[_vm._v(" "+_vm._s(this.label)+" ")]):_vm._e(),_c('div',_vm._b({class:_vm.label?'tx':'tx_sinlabel',style:(_vm.stilot)},'div',_vm.$attrs,false),[_vm._v(" "+_vm._s(this.txt)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }